const SDK = {
  BASE_URL: "https://minimis.cloud",
  STRPE_KEY:'pk_live_51Mq48pCHhPy4gmdpHje6ECXZRh9uYTmYFVm6sT3spEPtpwDWDBxDQRLe2dny342Mi3zRms5yHvOvhl9lbYrNb8Xu00np6bOu70',
  PIXEL_ID:"723846736228693"
};

export default SDK;
